import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/Modal/index'

class ProcessingModal extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    currentItem: PropTypes.object,
    toggleProcessing: PropTypes.func,
  }

  render() {
    const { translate, toggleProcessing, currentItem } = this.props
    return (
      <Modal
        title={translate('irc.processing.title')}
        renderButton={false}
        isOpen
        size={'md'}
        onCloseModal={() => toggleProcessing(false)}
        onConfirm={() => toggleProcessing(false)}
        hideCancelButton
        confirmButtonText={'Fechar'}
      >
        <div className='new-style margin-top w-100'>
          <table cellPadding={0} cellSpacing={0} className='new-table bordered'>
            <thead>
              <tr>
                <th>{translate('rotativeInventory.cdLm')}</th>
                <th>{translate('rotativeInventory.dsProduct')}</th>
              </tr>
            </thead>
            <tbody>
              {(currentItem.lsRotativeInventoryModel || []).map((val, k) => (
                <tr key={k}>
                  <td>{val.cdLm}</td>
                  <td>{val.dsProduct}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    )
  }
}

export default ProcessingModal
export { ProcessingModal }
